import './shims/lodash-wechat-polyfill';
import './shims/childnode-remove';
import './shims/class-list';
import './shims/element-closest';
import './shims/element-matches';
import './shims/element-dataset';
import './shims/modernizr-shim';
import './shims/object-assign';
import 'promise-polyfill/src/polyfill';
import 'nodelist-foreach-polyfill';
import 'string.prototype.repeat';

// require our libs
import './lib/browser';
import './lib/cookies';
import './lib/consent';
import './lib/accessibility';
import './lib/responsive';
import './lib/links';
import './lib/webworkers';
import './lib/swinger';
import './lib/matomo';
import './lib/redirect-to-preferred-host';

// require misc stuff
import './misc/checkout';

import taikoComponent from './lib/component';

import responsiveImagesManager from './modules/ResponsiveImagesManager';
import dynamicLoader from './modules/DynamicLoader';
import tcLoader from './modules/Loader';

import LazyLoadingImage from './modules/LazyLoadingImage';
import Header from './modules/Header';
import Sticky from './modules/Sticky';
import Selector from './modules/Selector';
import styleSelect from './modules/styleSelect';
import SplitDropdown from './modules/SplitDropdown';
import AddTo from './modules/AddTo';
/* import slider.stage from './modules/slider.stage'; */
import Overlay from './modules/Overlay';
import LightBox from './modules/LightBox';
import Tabs from './modules/Tabs';
import TabsSwipeable from './modules/TabsSwipeable';
import Accordion from './modules/Accordion';
import Faccordion from './modules/Faccordion';
import TabSelector from './modules/TabSelector';
import SpecialSelector from './modules/SpecialSelector';
import SortingDisplay from './modules/SortingDisplay';
import OverflowingSwiper from './modules/OverflowingSwiper';
import ParallaxCover from './modules/ParallaxCover';
import ReviewForm from './modules/ReviewForm';
import TagOverlay from './modules/TagOverlay';
import AjaxForm from './modules/AjaxForm';
import DownloadForm from './modules/DownloadForm';
import PurchaseVisibility from './modules/PurchaseVisibility';
import Autocomplete from './modules/Autocomplete';
import MultiSelector from './modules/MultiSelector';
import Dropdown from './modules/Dropdown';
import FormSubfields from './modules/FormSubfields';
import FilterSubmit from './modules/FilterSubmit';
import RangSlider from './modules/RangSlider';
import Validator from './modules/Validator';
import Form from './modules/Form';
import StepHandlerMobile from './modules/StepHandlerMobile';
import AccordionRadioBtn from './modules/AccordionRadioBtn';
import EditAccountData from './modules/EditAccountData';
import BackToTop from './modules/BackToTop';
/* import Coupon from './modules/Coupon'; */
import Switch from './modules/Switch';
import CartHint from './modules/CartHint';
import Reminder from './modules/Reminder';
import AppNotification from './modules/AppNotification';
import Quickview from './modules/Quickview';
import Tooltip from './modules/Tooltip';
import Dismissable from './modules/Dismissable';
import ContentLoader from './modules/ContentLoader';
import BulkContentLoader from './modules/BulkContentLoader';
import DataHref from './modules/DataHref';
import AutoSubmit from './modules/AutoSubmit';
import Back from './modules/Back';
import SafeSubmit from './modules/SafeSubmit';
import AjaxLoad from './modules/AjaxLoad';
import CookieConsent from './modules/CookieConsent';
import HrefLang from './modules/Hreflang';
import DataDeleteAddress from './modules/DataDeleteAddress';

import './modules/Carousel';
import './modules/DownloadLink';

// Swingerclub components
import SwingerWidget from './modules/SwingerWidget';
import translations from './misc/translations';
import Clipboard from "./modules/Clipboard";

// export to global
window.taikoComponent = taikoComponent;
window.responsiveImagesManager = responsiveImagesManager;
window.dynamicLoader = dynamicLoader;
window.tcLoader = tcLoader;

window.appStrings = translations;

// TODO: make importable js file for build

/**
 * Example
 *
 * [register description]
 * @method register
 *
 * DTaikoComponent.register(require('./modules/header'), '.tc-header');
 *
 */

const modules = [
  {
    modulePath: LazyLoadingImage,
    selector: '.tc-lazy-loading-image, .tc-blurry-background-image'
  },
  {
    modulePath: Header,
    selector: '.tc-header'
  },
  {
    modulePath: Sticky,
    selector: '.tc-sticky-nav'
  },
  {
    modulePath: Selector,
    selector: '.tc-selector'
  },
  {
    modulePath: styleSelect,
    selector: '.tc-style-selector'
  },
  {
    modulePath: SplitDropdown,
    selector: '.tc-split-dropdown'
  },
  {
    modulePath: AddTo,
    selector: '.tc-add-to'
  },
  /* {
    modulePath: slider.stage,
    selector: '.tc-slider-stage'
  }, */
  {
    modulePath: Quickview,
    selector: '.tc-quickview-wrapper'
  },
  {
    modulePath: Overlay,
    selector: '.tc-overlay, .tc-quickview-button'
  },
  {
    modulePath: LightBox,
    selector: '.tc-light-box, .tc-video-box'
  },
  {
    modulePath: CookieConsent,
    selector: '.tc-cookie-compliance'
  },
  {
    modulePath: Tabs,
    selector: '.tc-tabs'
  },
  {
    modulePath: TabsSwipeable,
    selector: '.tc-tabs-swipeable'
  },
  {
    modulePath: Accordion,
    selector: '.tc-accordion'
  },
  {
    modulePath: Faccordion,
    selector: '.tc-faccordion'
  },
  {
    modulePath: TabSelector,
    selector: '.tc-tab-selector'
  },
  {
    modulePath: SpecialSelector,
    selector: '.tc-special-selector'
  },
  {
    modulePath: SortingDisplay,
    selector: '.tc-sorting-display'
  },
  {
    modulePath: OverflowingSwiper,
    selector: '.tc-overflowing-slider.tc-auto-init' // without class tc-auto-init, you have to load it manually
  },
  {
    modulePath: ParallaxCover,
    selector: '.tc-parallax-cover'
  },
  {
    modulePath: ReviewForm,
    selector: '.tc-review-form'
  },
  {
    modulePath: TagOverlay,
    selector: '.tc-tag-overlay'
  },
  {
    modulePath: AjaxForm,
    selector: '.tc-ajax-form'
  },
  {
    modulePath: DownloadForm,
    selector: '.tc-download-form'
  },
  {
    modulePath: PurchaseVisibility,
    selector: '.tc-purchase-visibility'
  },
  {
    modulePath: Autocomplete,
    selector: '.tc-search, .tc-autocomplete'
  },
  {
    modulePath: MultiSelector,
    selector: '.tc-multi-selector'
  },
  {
    modulePath: Dropdown,
    selector: '.tc-dropdown'
  },
  {
    modulePath: FormSubfields,
    selector: '.tc-toggle-subfields'
  },
  {
    modulePath: FilterSubmit,
    selector: '.tc-filter'
  },
  {
    modulePath: RangSlider,
    selector: '.tc-range-slider-wrapper'
  },
  {
    modulePath: Validator,
    selector: '[data-validator]'
  },
  {
    modulePath: Form,
    selector: '[data-form]'
  },
  {
    modulePath: StepHandlerMobile,
    selector: '.tc-mobile-step-listener'
  },
  {
    modulePath: AccordionRadioBtn,
    selector: '.tc-accordion-radio'
  },
  {
    modulePath: EditAccountData,
    selector: '.tc-edit-data'
  },
  {
    modulePath: BackToTop,
    selector: '.tc-back-to-top'
  },
  /* {
    modulePath: Coupon,
    selector: '.tc-coupon'
  }, */
  {
    modulePath: Switch,
    selector: '.tc-switch'
  },
  {
    modulePath: CartHint,
    selector: '.tc-add-to-cart'
  },
  {
    modulePath: Reminder,
    selector: '.tc-set-reminder'
  },
  {
    modulePath: AppNotification,
    selector: '.tc-app-notification'
  },
  {
    modulePath: Quickview,
    selector: '.tc-quickview'
  },
  {
    modulePath: Tooltip,
    selector: '.tc-tooltip'
  },
  {
    modulePath: Dismissable,
    selector: '.is-dismissable'
  },
  {
    modulePath: Clipboard,
    selector: '.tc-clipboard'
  },
  {
    modulePath: ContentLoader,
    selector: '[data-content-url]'
  },
  {
    modulePath: BulkContentLoader,
    selector: '[data-bulk-content-url]'
  },
  {
    modulePath: DataHref,
    selector: '[data-href]'
  },
  {
    modulePath: AutoSubmit,
    selector: [
      'form.is-filter-extra input',
      '.auto-submit select',
      '.auto-submit input[type="radio"]',
      'input.auto-submit',
      'select.auto-submit'
    ].join(',')
  },
  {
    modulePath: Back,
    selector: '.is-back'
  },
  {
    modulePath: SafeSubmit,
    selector: 'button.safe-submit'
  },
  {
    modulePath: AjaxLoad,
    selector: '.jq-load[href]'
  },
  {
    modulePath: HrefLang,
    selector: '[hreflang]'
  },
  {
    modulePath: DataDeleteAddress,
    selector: '[data-delete-address]'
  },
  {
    modulePath: SwingerWidget,
    selector: '[data-swinger-widget]'
  }
];


taikoComponent.ready(() => {

  window.responsiveImagesManager.setup();

  modules.map(component => {

    taikoComponent.register(component.modulePath, component.selector);
  });
  window.dynamicLoader.setup();
  window.AddTo = AddTo;
  document.documentElement.classList.add('is-loaded');
});

// let loadCSSMainFile = null;
//
// /*
//  * fallback when loadcss isn't loaded - maybe remove async from script-tag instead
//  */
// if ( typeof loadCSS !== 'undefined' ) {
//
//   loadCSSMainFile = loadCSS('./css/main.css');
// } else {
//
//   loadCSSMainFile = document.createElement('link');
//   loadCSSMainFile.rel = 'stylesheet';
//   loadCSSMainFile.type = 'text/css' ;
//   loadCSSMainFile.href = './css/main.css';
//   document.head.appendChild(loadCSSMainFile);
// }
//
// if ( loadCSSMainFile ) {
//
//   loadCSSMainFile.addEventListener('load', () => {
//
//     taikoComponent.register(require('./modules/LazyLoadingImage'), '.tc-lazy-loading-image');
//     taikoComponent.register(require('./modules/slider.stage'), '.tc-slider-stage');
//   }, true);
//
// } else {

// taikoComponent.register(require('./modules/LazyLoadingImage'), '.tc-lazy-loading-image');
// taikoComponent.register(require('./modules/slider.stage'), '.tc-slider-stage');
// taikoComponent.register(require('./modules/Quickview'), '.tc-quickview');
// taikoComponent.register(require('./modules/Modal'), '.tc-modal');
// }
